<div class="bmc-package-visualizer">
  <biz-package-visualizer-topbar (onClose)="close()"
                                 [packageName]="_packageData.packageName"
    (onSetSearchMode)="setSearchMode($event)"
    (onSearchText)="searchText($event)">
  </biz-package-visualizer-topbar>
  <div class="bmc-package-visualizer__main-section" *ngIf="!isSearchMode">
    <biz-package-visualizer-breadcrumb [pathList]="(navigation$ | async)" (onNavigate)="selectCatalogObject($event)">

    </biz-package-visualizer-breadcrumb>
    <biz-package-visualizer-list
      [isLoading]="(isLoadingList$ | async)"
      [catalogObjects]="(catalogObjectList$ | async)"
      (onSelectCatalogObject)="selectCatalogObject($event)">
    </biz-package-visualizer-list>
  </div>
  <div *ngIf="isSearchMode" class="bmc-package-visualizer__empty">
    <biz-package-search-container [catalogObjects]="(catalogObjectList$ | async)"></biz-package-search-container>
  </div>
</div>
